import { Link, useHistory } from 'react-router-dom'
import { Layout, Dropdown, Menu, Row, Col } from 'antd'
import {
  UserOutlined,
  BellOutlined,
  SettingOutlined,
  LogoutOutlined
} from '@ant-design/icons'
import { routesConfig } from '../../core/configs/routes'
import { colors } from '../../core/theme'
import { useAuthContext } from '../../core/components'

const { Header } = Layout

export const LayoutHeader = () => {
  const history = useHistory()
  const { logOut } = useAuthContext()

  const handleLogOut = async () => {
    logOut()
    history.push(routesConfig.auth.login)
  }

  const account = (
    <Menu>
      <Menu.Item key="0">
        <Link to="">
          <UserOutlined /> Perfil
        </Link>
      </Menu.Item>
      <Menu.Item key="1">
        <Link to="">
          <SettingOutlined /> Configurações
        </Link>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="2" onClick={handleLogOut}>
        <LogoutOutlined /> Sair
      </Menu.Item>
    </Menu>
  )

  const notification = (
    <div
      style={{
        width: 300,
        height: 100,
        backgroundColor: '#fff',
        borderRadius: '2px',
        boxShadow:
          '0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05)'
      }}
    >
      <div style={{ padding: '20px' }}>
        <h3>Notificações</h3>
      </div>
    </div>
  )

  return (
    <Header
      style={{
        position: 'fixed',
        zIndex: 1,
        width: '100%',
        padding: 0,
        backgroundColor: colors.primary
      }}
    >
      <Row align="middle" justify="end">
        <Col order={1}>
          <Dropdown overlay={notification}>
            <div className="toolbar-item">
              <BellOutlined style={{ fontSize: '18px', color: '#fff' }} />
            </div>
          </Dropdown>
        </Col>
        <Col order={2}>
          <Dropdown overlay={account}>
            <div className="toolbar-item">
              <UserOutlined style={{ fontSize: '18px', color: '#fff' }} />
            </div>
          </Dropdown>
        </Col>
      </Row>
    </Header>
  )
}
